import { useInvestorQuickLinks } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/useInvestorQuickLinks.ts';
import { QuickLinksSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/QuickLinksCard/QuickLinksSection.tsx';

interface Props {
	dealId: string;
	mipId: string;
	investorId: string;
	isInvestorLoading?: boolean;
}

export const QuickLinksCard = ({ dealId, mipId, investorId, isInvestorLoading = false }: Props) => {
	const { links, isLoading, isError } = useInvestorQuickLinks({ dealId, mipId, investorId });

	return (
		<QuickLinksSection
			links={links}
			isLoading={isLoading || isInvestorLoading}
			isError={isError}
		/>
	);
};
